import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import { install as simpleSeriesExtensionInstall } from './simpleSeriesPlugin';
import { install as seriesWithCoordSysLayoutExtensionInstall } from './seriesWithCoordSysLayoutPlugin';

export function install(registers: EChartsExtensionInstallRegisters) {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  simpleSeriesExtensionInstall(registers);
  seriesWithCoordSysLayoutExtensionInstall(registers);
}
